module.exports = __webpack_public_path__ + "img/template2.cc1de666.png";